import React, {useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { BaseUrl } from "../../../Actions/Base";
import NoDataResponse from "../../../Components/NoDataResponse";

// ─── Tooltip Cell ───────────────────────────────────────────────
const TooltipCell = ({ count, emails }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  if (!count || count === 0) {
    return <td className="text-center py-3 text-[#174A84]">0</td>;
  }

  return (
    <td className="text-center py-3 text-[#174A84] relative">
      <span
        ref={ref}
        className="cursor-pointer underline decoration-dotted"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {count}
      </span>

      {visible && emails?.length > 0 && (
        <div
          className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2
                     bg-white border border-[#AEAEFE] rounded-[10px] shadow-lg
                     px-3 py-2 min-w-[200px] max-w-[280px] text-left"
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => setVisible(false)}
        >
          {/* Arrow pointer */}
          <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0"
            style={{
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid #AEAEFE",
            }}
          />
          <p className="text-[11px] font-semibold text-[#8773DC] mb-1 uppercase tracking-wide">
            Registered Users
          </p>
          <ul className="space-y-1">
            {emails.map((email, i) => (
              <li key={i} className="text-[12px] text-[#174A84] truncate">
                {email}
              </li>
            ))}
          </ul>
        </div>
      )}
    </td>
  );
};


const Archive= ({ appliedFilters }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [weeklyData, setWeeklyData] = useState(null);
    const [monthlyData, setMonthlyData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [sortAsc, setSortAsc] = useState(false); // ← default: latest first


//    useEffect(() => {
//     fetch("/api/Analytics/GetWeeklyMonthlyAnalytics")
//         .then((res) => res.json())
//         .then((data) => {
//         if (data.success) {
//             setWeeklyData(data.data);
//         }
//         })
//         .catch((err) => console.error(err));
//     }, []);


   useEffect(() => {
    const fetchData = async () => {
        setLoading(true); // 🔥 start loading

        try {
        let url = "/api/Analytics/GetWeeklyMonthlyAnalytics";

        const params = new URLSearchParams();

        if (appliedFilters?.FromDate) {
            params.append(
            "fromDate",
            new Date(appliedFilters.FromDate).toISOString()
            );
        }

        if (appliedFilters?.ToDate) {
            params.append(
            "toDate",
            new Date(appliedFilters.ToDate).toISOString()
            );
        }

        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const res = await fetch(url);
        const data = await res.json();

        if (data.success) {
            setWeeklyData(data.data);
        }
        } catch (err) {
        console.error(err);
        } finally {
        setLoading(false); // 🔥 stop loading
        }
    };

    fetchData();
    }, [appliedFilters]);

    const formatDateRange = (start, end) => {
    const options = { day: "numeric", month: "short" };

    return `${new Date(start).toLocaleDateString("en-GB", options)} - 
    ${new Date(end).toLocaleDateString("en-GB", options)}`;
    };

    const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}m ${s}s`;
    };

    // Sort before rendering
  const sortedData = weeklyData
    ? [...weeklyData].sort((a, b) => {
        const diff = new Date(a.startDate) - new Date(b.startDate);
        return sortAsc ? diff : -diff;
      })
    : [];

    return (
        <div className="flex w-full flex-col gap-[40px] justify-center items-center mt-[40px]">

           <div className="w-[90%] rounded-[16px] py-[90px]"
            style={{
                    background: 'transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%) 0% 0% no-repeat padding-box',
                    boxShadow: '0px 0px 12px #AEAEFE',
                }}>

                <table className="w-full text-left border-collapse">
                    {/* Table Head */}
                    <thead 
                   >
                        <tr className="text-[#FFFFFF] text-[19px] font-normal"
                        style={{
                            background:
                                'transparent linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%) 0% 0% no-repeat padding-box',
                            }}>
                        {/* <th className="px-2 py-3 w-[20%] text-center">Month/Week</th> */}
                        {/* ← Clickable sort column */}
                            <th
                                className="px-2 py-3 w-[20%] text-center cursor-pointer select-none"
                                onClick={() => setSortAsc(prev => !prev)}
                            >
                                Week{" "}
                                <span className="inline-block ml-1 text-sm">
                                {sortAsc ? "▲" : "▼"}
                                </span>
                            </th>
                            <th className="text-center py-3 w-[20%] ">Total Visitors</th>
                            <th className="py-3 w-[20%] text-center">Avg Time Spent</th>
                            <th className="py-3 w-[20%] text-center">Learner Registered</th>
                            <th className="text-center py-3 w-[20%]">Partner Registered</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                            <td colSpan="5" className="text-center py-10">
                                <p className="text-[#174A84] text-lg">Loading...</p>
                            </td>
                            </tr>
                        ) : !weeklyData || weeklyData.length === 0 ? (
                            <tr>
                            <td colSpan="5" className="text-center py-10">
                                <NoDataResponse topText="No Data Found" />
                            </td>
                            </tr>
                        ) : (
                            sortedData.map((week, index) => (
                            <tr key={index}>
                                <td className="text-center py-3 text-[#174A84]">
                                {formatDateRange(week.startDate, week.endDate)}
                                </td>
                                <td className="text-center py-3 text-[#174A84]">
                                {week.totalVisitors}
                                </td>
                                <td className="text-center py-3 text-[#174A84]">
                                {formatTime(week.avgTimeSpent)}
                                </td>
                                {/* <td className="text-center py-3 text-[#174A84]">
                                {week.newLearners}
                                </td>
                                <td className="text-center py-3 text-[#174A84]">
                                {week.newPartners}
                                </td> */}
                                 {/* ← Tooltip cells */}
                                <TooltipCell
                                    count={week.newLearners}
                                    emails={week.newLearnerIds}
                                />
                                <TooltipCell
                                    count={week.newPartners}
                                    emails={week.newPartnerIds}
                                />
                            </tr>
                            ))
                        )}
                    </tbody>

                    {/* <tbody>
                        {!weeklyData ? (
                            <tr>
                            <td colSpan="7" className="text-center py-10">
                                <NoDataResponse
                                topText="No Data Found"
                                // bottomText="Publish a blog to see it here"
                                />
                            </td>
                            </tr>
                        ) : (
                            <>
                                {weeklyData.map((week, index) => (
                                    <tr key={index}>
                                        <td className="text-center py-3 text-[#174A84]">
                                        {formatDateRange(week.startDate, week.endDate)}
                                        </td>

                                        <td className="text-center py-3 text-[#174A84]">
                                        {week.totalVisitors}
                                        </td>

                                        <td className="text-center py-3 text-[#174A84]">
                                        {formatTime(week.avgTimeSpent)}
                                        </td>

                                        <td className="text-center py-3 text-[#174A84]">
                                        {week.newLearners}
                                        </td>

                                        <td className="text-center py-3 text-[#174A84]">
                                        {week.newPartners}
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody> */}

                </table>

           </div>
        </div>
    );
};

export default Archive;
